import { rbac } from "../index";
import { Biscuit } from "../../../../utils";
import t from "../../../helpers/t";
import { moment } from "../../../../../vendor";
import NextPageBtn from "../../../components/NextPageBtn";
import React, { useState } from "react";
import * as Function from "./Functions";
import TasksListItem from "./TasksListItem";

const TasksList = (props) => {
  const { showCheckBoxes, checkedItems, onCheckBox } = props;

  let tasksData = [];
  const currentUrl = new URL(window.location.href);
  const getStatusSelect = (task) => {
    let status = task.status;
    // noinspection UnnecessaryLocalVariableJS
    let stat = [
      { text: t("new", null, "capital"), value: "new", disabled: "", selected: status === "new" },
      {
        text: t("in_progress", null, "capital"),
        value: "inprogress",
        disabled: "",
        selected: status === "inprogress",
      },
      {
        text: t("done", null, "capital"),
        value: "done",
        disabled: "",
        selected: status === "done",
      },
    ];

    return stat;
  };

  const onDeleteItem = (task) => {
    props.onRemoveTask(task);
  };

  const fillData = () => {
    if (typeof props.tasks === "undefined") return;

    let task,
      hasComments = false;
    for (let i = 0; i < props.tasks.length; i++) {
      task = props.tasks[i];
      hasComments = typeof task.task_comments !== "undefined" && task.task_comments;
      let endStyleClass = {
        fontWeight: "normal",
        color: "#5D687E",
      };
      if (task.status === "new") {
        endStyleClass["fontWeight"] = "bold";
      }
      if (task.status !== "done" && moment(task.end).diff(moment(), "seconds") < 0) {
        endStyleClass["color"] = "red";
      }
      /* let editAloneSmall = {
                type: "specialButtons",
                value: t('actions'),
                title: t('actions'),
                extraTopClasses: "show-for-small-only",
                data: [{
                    value: task.id,
                    icon: "inb-fi-edit",
                    extraClasses: "inb-round-btn hollow round float-left",
                    ref: "/tasks/" + task.id + currentUrl.search,
                    round: true
                }],
                mediumWidth: 1,
                smallWidth: 2,
                handler: null
            };
            let deleteAloneSmall = {
                type: "specialButtons",
                value: t('actions'),
                title: t('actions'),
                extraTopClasses: "show-for-small-only",
                data: [{
                    value: task,
                    icon: "inb-fi-remove",
                    extraClasses: "inb-round-btn hollow round float-left",
                    ref: "#",
                    round: true,
                    handler: onDeleteItem
                }],
                mediumWidth: 1,
                smallWidth: 2,
                handler: onDeleteItem,
            };
            let bothSmall = {
                type: "specialButtons",
                value: t('actions'),
                title: t('actions'),
                extraTopClasses: "show-for-small-only",
                data: [{
                    value: task.id,
                    icon: "inb-fi-edit",
                    extraClasses: "inb-round-btn hollow round float-left",
                    ref: "/tasks/" + task.id + currentUrl.search,
                    round: true
                }, {
                    value: task,
                    icon: "inb-fi-remove",
                    extraClasses: "inb-round-btn hollow round float-left",
                    extraStyle: { marginLeft: '55px' },
                    ref: "#",
                    round: true,
                    handler: onDeleteItem
                }],
                mediumWidth: 1,
                smallWidth: 4,
                handler: onDeleteItem
            }; */

      let elements = [
        {
          type: "checkBox",
          value: "",
          title: t("selection", null, "capital"),
          data: {
            name: task.id,
            onChange: onCheckBox,
            value:
              checkedItems !== {} &&
              typeof checkedItems[task.id] !== undefined &&
              checkedItems[task.id],
            checkBoxLabel: false,
            switchStyle: {},
          },
          largeWidth: 1,
          mediumWidth: 1,
          smallWidth: 1,
          extraTopClasses: "show-for-large",
        },
        {
          type: "text",
          value: "task_nbr",
          title: t("task_nbr", null, "capital"),
          data: [
            {
              value: task.task_nbr,
              text: task.task_nbr,
              extraClasses: "medium-offset-0  show-label",
              title: t("task_nbr", null, "capital"),
            },
          ],
          largeWidth: 1,
          mediumWidth: 8,
          smallWidth: 8,
          extraTopClasses: "show-label",
        },
      ];
      /* if (rbac.hasPermission('editTask')) {
                if (rbac.hasPermission('delete') || props.task.created_by === Biscuit.get('user.id')) {
                    elements.push(bothSmall);
                } else {
                    elements.push(editAloneSmall)
                }
            } else {
                if (rbac.hasPermission('delete') || props.task.created_by === Biscuit.get('user.id')) {
                    elements.push(deleteAloneSmall);
                }
            } */

      elements.push({
        type: "function",
        value: "designation",
        title: t("designation", null, "capital"),
        data: [
          {
            value: task.designation,
            text: Function.getDescription(
              task,
              props.userQueue,
              props.setUserQueue,
              props.extraUsers,
            ),
            extraClasses: "inb-order-big",
            title: t("designation", null, "capital"),
          },
        ],
        largeWidth: 2,
        mediumWidth: 12,
        smallWidth: 12,
        extraTopClasses: "show-label",
      });
      elements.push({
        type: "text",
        value: "assignment",
        title: t("assigned", null, "capital"),
        data: [
          {
            value: "assignment",
            text:
              task.user === undefined || task.user == null
                ? "-"
                : task.user.first_name + " " + task.user.last_name,
            ref:
              task.user === undefined || task.user == null
                ? "#"
                : Function.getObjectReference("Users", task.assignee),
            extraClasses: "medium-offset-0",
            title: t("assignment", null, "capital"),
          },
        ],
        largeWidth: 2,
        mediumWidth: 10,
        smallWidth: 10,
        handler: null,
        extraTopClasses: "show-label",
      });
      elements.push({
        type: "text",
        value: "created",
        title: t("created_at", null, "capital"),
        data: [
          {
            value: "created",
            text: task.created == null ? "" : moment(task.created).format("DD.MM.YYYY HH:mm:ss"),
            extraClasses: "medium-offset-0",
            title: t("created_at", null, "capital"),
          },
        ],
        largeWidth: 2,
        mediumWidth: 8,
        smallWidth: 8,
        extraTopClasses: "show-label",
      });
      /* elements.push({
                type: "select",
                value: task.status,
                title: t('status'),
                data: getStatusSelect(task),
                extraTopClasses: "show-for-small-only",
                extraClasses: "text-small word-break-all",
                extraData: task,
                largeWidth: 2,
                mediumWidth: 2,
                smallWidth: 6,
                badge: true,
                handler: props.onChangeItemStatus
            }); */
      elements.push({
        type: "text",
        value: "end",
        title: t("done_until") + " " + t("till"),
        data: [
          {
            value: "end",
            text: task.end == null ? "" : moment(task.end).format("DD.MM.YYYY HH:mm:ss"),
            extraClasses: "medium-offset-0",
            extraStyle: endStyleClass,
            title: t("end", null, "capital"),
          },
        ],
        largeWidth: 2,
        mediumWidth: 8,
        smallWidth: 8,
        extraClasses: "",
        extraTopClasses: "show-label",
      });
      elements.push({
        type: "select",
        value: task.status,
        title: t("status", null, "capital"),
        /* extraTopClasses: "hide-for-small-only", */
        data: getStatusSelect(task),
        extraData: task,
        extraClasses: "text-small word-break-all",
        largeWidth: 1,
        mediumWidth: 8,
        smallWidth: 8,
        extraTopClasses: "show-label",
        badge: true,
        handler: props.onChangeItemStatus,
      });
      let editAlone = {
        type: "specialButtons",
        value: t("actions"),
        title: t("actions"),
        extraTopClasses: "",
        data: [
          {
            value: task.id,
            icon: "inb-fi-edit",
            extraClasses: "inb-round-btn hollow round float-left",
            ref: "/tasks/" + task.id + currentUrl.search,
            round: true,
          },
        ],
        mediumWidth: 1,
        smallWidth: 1,
        largeWidth: 1,
        handler: null,
      };
      let deleteAlone = {
        type: "specialButtons",
        value: t("actions"),
        title: t("actions"),
        extraTopClasses: "",
        data: [
          {
            value: task,
            icon: "inb-fi-remove",
            extraClasses: "inb-round-btn hollow round float-left",
            ref: "#",
            round: true,
            handler: onDeleteItem,
          },
        ],
        mediumWidth: 1,
        smallWidth: 1,
        largeWidth: 1,
        handler: onDeleteItem,
      };
      let both = {
        type: "specialButtons",
        value: t("actions"),
        title: t("actions"),
        extraTopClasses: "",
        data: [
          {
            value: task.id,
            icon: "inb-fi-edit",
            extraClasses: "inb-round-btn hollow round float-left",
            ref: "/tasks/" + task.id + currentUrl.search,
            round: true,
          },
          {
            value: task,
            icon: "inb-fi-remove",
            extraClasses: "inb-round-btn hollow round float-left",
            extraStyle: { marginLeft: "55px" },
            ref: "#",
            round: true,
            handler: onDeleteItem,
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
        largeWidth: 1,
        handler: onDeleteItem,
      };

      if (rbac.hasPermission("editTask")) {
        if (rbac.hasPermission("delete") || props.task.created_by === Biscuit.get("user.id")) {
          elements.push(both);
        } else {
          elements.push(editAlone);
        }
      } else {
        if (rbac.hasPermission("delete") || props.task.created_by === Biscuit.get("user.id")) {
          elements.push(deleteAlone);
        }
      }
      tasksData.push({ elements: elements });
    }
  };
  fillData();

  return (
    <>
      <div className="inb-c-listing off-canvas-content" id="inb-c-main-orders">
        {typeof props.tasks !== "undefined" &&
          props.tasks.length > 0 &&
          props.tasks.map((task, index) => {
            return (
              <>
                {typeof tasksData[index].elements !== "undefined" && (
                  <TasksListItem
                    key={"wta-" + index}
                    listStyle="tight"
                    id={"tasks-item-" + task.id}
                    overwriteClasses={"inb-c-item inb-c-item--order inb-c-item-task row"}
                    elements={tasksData[index].elements}
                    task={task}
                    dispatch={props.dispatch}
                    rbac={rbac}
                    onRemoveTask={props.onRemoveTask}
                  />
                )}
              </>
            );
          })}
      </div>
    </>
  );
};

export default TasksList;
